
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.159 4.557l-.897-1.817-.897 1.817-3.665 7.426-8.195 1.191-2.005.291 1.451 1.415 5.93 5.78-1.4 8.162-.342 1.997 1.793-.943 7.33-3.854 7.33 3.854 1.793.943-.343-1.997-1.4-8.162 5.93-5.78 1.451-1.415-2.005-.291-8.195-1.19-3.665-7.427z","fill":"#fff","stroke":"#525F7F","stroke-width":"2"}})])
          )
        }
      }
    